import type { CalendarJob } from "./job-chip";

type Row = Record<string, unknown>;

export function toCalendarJob(row: Row): CalendarJob {
  const status = (row.status as string) ?? "scheduled";
  return {
    id: row.id as string,
    label:
      (row.customer_name as string) ||
      (row.job_number as string) ||
      (row.name as string) ||
      "Job",
    status,
    canceled: status === "canceled",
    crew: (row.crew_name as string | null) ?? null,
    customer: (row.customer_name as string | null) ?? null,
    jobNumber: (row.job_number as string | null) ?? null,
    productionStartDate: (row.production_start_date as string | null) ?? null,
    productionEndDate: (row.production_end_date as string | null) ?? null,
    hasCrewConflict:
      (row.has_crew_conflict as boolean | null | undefined) ?? false,
  };
}

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export function selectSpanningJobs(rows: Row[]): CalendarJob[] {
  const out: CalendarJob[] = [];
  for (const row of rows) {
    const start = (
      row.production_start_date as string | null | undefined
    )?.slice(0, 10);
    const end = (row.production_end_date as string | null | undefined)?.slice(
      0,
      10,
    );
    if (!start || !end) continue;
    if (!DATE_RE.test(start) || !DATE_RE.test(end)) continue;
    if (start > end) continue;
    out.push(toCalendarJob(row));
  }
  return out;
}
